import mixpanel from "mixpanel-browser";

export function setUser(id, properties) {
  mixpanel.alias(id);
  mixpanel.people.set(properties);
}
export function identify(id, properties) {
  mixpanel.identify(id);
}

export function trackEvent(customEvent, properties, cb) {
  return mixpanel.track(customEvent, properties, cb);
}

export function increment(property) {
  return mixpanel.people.increment(property);
}



// WEBPACK FOOTER //
// ./src/core/integrations/mixpanel/index.js